import React, {useState} from 'react';
import {Button, Goods,} from "@chatui/core";
import GoodsSelect from "./goodsSelect"

function ProductsInput(props) {

    const {
        currency,
        goodsList,
        setGoodsList,
        language,
    } = props;

    const defaultText = language==="zh_cn"? "还没有选择任何商品": "There is no selected products.";
    const defaultTitle = language==="zh_cn"? "选择商品": "Select Products";
    const defaultButtonText = language==="zh_cn"? "选择": "Select";
    const defaultCartText = language==="zh_cn"? "购物车": "Cart";
    const defaultTotalPriceText = language==="zh_cn"? "合计：": "Total Price: ";

    const [openSelect, setOpenSelect] = useState(false);

    const allGoodsList =  {
        'Substantial Dish': [{
            "name": "Dried Chili Chicken",
            "price": "28",
            "desc": "spicy chicken",
            "img": "/images/laziji.png"
        },
            {
                "name": "Mala Fish",
                "price": "38",
                "desc": "spicy fish",
                "img": "/images/shuizhuyu.png"
            }],
        'drinks': [{
            "name": "Coca cola",
            "price": "5",
            "desc": "Coca cola",
            "img": "/images/default.png"
        }],
        'Main Food': [{
            "name": "rice",
            "price": "2",
            "desc": "rice",
            "img": "/images/default.png"
        }],
        "Stir-Fried Dish": [{
            "name": "Yuxiang Shredded Pork",
            "price": "19",
            "desc": "carrot and pork, with sweet and sour flavour.",
            "img": "/images/default.png"
        }]
    }


    const deleteGoods = (index) => {
        const newGoodsList = [...goodsList];
        newGoodsList.splice(index, 1);
        setGoodsList(newGoodsList);
    }

    return (
        <>
            {goodsList.length===0?(
                <p>{defaultText}</p>
            ):(
                <div className={"products-list"}>
                    {props.goodsList.map((item, index)=>(
                        <Goods
                            key={index}
                            name={item.name}
                            img={item.img}
                            price={item.price}
                            desc={item.desc}
                            count={item.count}
                            currency={currency}
                            action={{
                                icon: "close",
                                onClick: ()=>{deleteGoods(index)}
                            }}
                        />
                    ))}
                </div>
            )}
            <GoodsSelect
                title={defaultTitle}
                cartText={defaultCartText}
                totalPriceText={defaultTotalPriceText}
                currency={currency}
                active={openSelect}
                onClose={()=>setOpenSelect(false)}
                onAcknowledge={(gl)=> {
                    setGoodsList(gl);
                    setOpenSelect(false);
                }}
                getGoodsList={()=>{
                    return new Promise((resolve)=>{
                        resolve(allGoodsList);
                    })
                }}
            />
            <Button onClick={()=>setOpenSelect(true)}>{defaultButtonText}</Button>
        </>
    );
}

export default ProductsInput;